import { render, staticRenderFns } from "./UseCategoryTemplate.vue?vue&type=template&id=28801724&scoped=true"
import script from "./UseCategoryTemplate.vue?vue&type=script&lang=js"
export * from "./UseCategoryTemplate.vue?vue&type=script&lang=js"
import style0 from "./UseCategoryTemplate.vue?vue&type=style&index=0&id=28801724&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28801724",
  null
  
)

export default component.exports